import { XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import * as React from 'react';
import { default as MainModal, Props as MainModalProps } from 'react-modal';

import { Button } from '@/components/Elements';

export interface ModalProps extends MainModalProps {
  isOpen: boolean;
  onAfterOpen?: () => void;
  onRequestClose?: () => void;
  style?: any;
  shouldCloseOnOverlayClick?: boolean;
  closeButton?: boolean;
  children?: React.ReactNode;
}

export const Modal = ({
  isOpen,
  onAfterOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  style,
  children,
  closeButton = true,
  ...props
}: ModalProps) => {
  MainModal.setAppElement('#root');

  const getModalStyles = () =>
    clsx(
      'md__modal p-2 md:py-8 md:px-10 bg-white text-xs absolute top-2 bottom-2 left-2 lg:top-10 lg:bottom-10 lg:left-10 lg:right-10 rounded-lg shadow-xl',
      {
        'right-6': closeButton,
        'right-2': !closeButton,
      }
    );

  const getCloseButton = () => (
    <Button
      onClick={onRequestClose}
      variant="raw"
      size="free"
      className="rounded-full p-3 absolute top-[0px] right-[0px] transition duration-150 ease-out hover:rotate-90"
      endIcon={<XIcon className="h-5 w-5 text-black" aria-hidden="true" />}
    />
  );

  return (
    <MainModal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      style={style}
      className={getModalStyles()}
      overlayClassName="md__modal__overlay"
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      htmlOpenClassName="md__modal__html overflow-hidden lg:pr-[17px]"
      bodyOpenClassName="md__modal__body overflow-hidden lg:pr-[17px]"
      preventScroll={true}
      {...props}
    >
      <>
        {closeButton && getCloseButton()}
        {children}
      </>
    </MainModal>
  );
};
